import Vue from 'vue'
import store from '@/store'

// plugins
import vDialog from 'v-dialogs'
import vPage from 'v-page'
// import vTableGrid from 'v-tablegrid';
import vUploader from 'v-uploader'
import vRegion from 'v-region'
import vSelectPage from 'v-selectpage'
import vSuggest from 'v-suggest'
import vPlayBack from 'v-playback'
import vSelectMenu from 'v-selectmenu'
import vGallery from 'v-gallery'

import i18n from '@/components/i18n'
import showCode from '@/components/showcode'
// import githubButton from '@/plugins/github-buttons/vue';
import githubButton from 'vue-github-button'
import markdown from '@/components/markdown'

import * as hooks from './hooks'

// font-awesome 5.x
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// import hljs from 'highlight.js'
// import javascript from 'highlight.js/lib/languages/javascript'
// import html from 'highlight.js/lib/languages/xml'
import 'highlight.js/styles/github.css'

import Code from '@/components/v-code'

const language = store.state.language

library.add(fas, fab, far)
FontAwesomeIcon.props.fixedWidth.default = true

Vue.component('FaIcon', FontAwesomeIcon)
Vue.use(vDialog)
Vue.use(vPage, { language: language })
// Vue.use(vTableGrid);
Vue.use(vUploader, hooks.uploaderConfig(language))
Vue.use(vRegion)
Vue.use(vSelectPage, {
  language: store.state.language,
  dataLoad: hooks.dataLoadConfig
})
Vue.use(vSuggest)
Vue.use(vPlayBack, {
  language: 'zh-CN'
})
Vue.use(vSelectMenu, {
  language: language
})
Vue.use(vGallery)

Vue.use(i18n)
Vue.use(showCode)
Vue.component('GhBtn', githubButton)

// highlight.js
// hljs.registerLanguage('javascript', javascript)
// hljs.registerLanguage('html', html)

Vue.use(Code)
Vue.use(markdown)
